/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MTP Service Mobile API
 * API REST pour l'espace client mobile - Migration Symfony 7.3
 * OpenAPI spec version: 2.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetApiNotification401,
  GetApiNotification403,
  GetApiNotification404,
  GetApiNotifications401,
  GetApiNotifications403,
  NotificationItemDTO,
  NotificationsResponse,
} from '../placementApi.schemas.ts';

import getApiNotificationMutator from '.././mutator/placement-instance.ts';
import getApiNotificationsMutator from '.././mutator/placement-instance.ts';

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Retrieves a single notification by its identifier.
 * @summary Get notification by id
 */
export const getApiNotification = (id: string, signal?: AbortSignal) => {
  return getApiNotificationMutator<NotificationItemDTO>({ url: `/api/notifications/${id}`, method: 'GET', signal });
};

export const getGetApiNotificationQueryKey = (id: string) => {
  return [`/api/notifications/${id}`] as const;
};

export const getGetApiNotificationQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiNotification>>,
  TError = GetApiNotification401 | GetApiNotification403 | GetApiNotification404,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotification>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiNotificationQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotification>>> = ({ signal }) =>
    getApiNotification(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiNotification>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiNotificationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotification>>>;
export type GetApiNotificationQueryError = GetApiNotification401 | GetApiNotification403 | GetApiNotification404;

export function useGetApiNotification<
  TData = Awaited<ReturnType<typeof getApiNotification>>,
  TError = GetApiNotification401 | GetApiNotification403 | GetApiNotification404,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotification>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotification>>,
          TError,
          Awaited<ReturnType<typeof getApiNotification>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiNotification<
  TData = Awaited<ReturnType<typeof getApiNotification>>,
  TError = GetApiNotification401 | GetApiNotification403 | GetApiNotification404,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotification>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotification>>,
          TError,
          Awaited<ReturnType<typeof getApiNotification>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiNotification<
  TData = Awaited<ReturnType<typeof getApiNotification>>,
  TError = GetApiNotification401 | GetApiNotification403 | GetApiNotification404,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotification>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get notification by id
 */

export function useGetApiNotification<
  TData = Awaited<ReturnType<typeof getApiNotification>>,
  TError = GetApiNotification401 | GetApiNotification403 | GetApiNotification404,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotification>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiNotificationQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Retrieves the list of notifications for the authenticated user.
 * @summary Get notifications
 */
export const getApiNotifications = (signal?: AbortSignal) => {
  return getApiNotificationsMutator<NotificationsResponse>({ url: `/api/notifications`, method: 'GET', signal });
};

export const getGetApiNotificationsQueryKey = () => {
  return [`/api/notifications`] as const;
};

export const getGetApiNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiNotifications>>,
  TError = GetApiNotifications401 | GetApiNotifications403,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotifications>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiNotificationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotifications>>> = ({ signal }) =>
    getApiNotifications(signal);

  return { queryKey, queryFn, staleTime: 1800000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotifications>>>;
export type GetApiNotificationsQueryError = GetApiNotifications401 | GetApiNotifications403;

export function useGetApiNotifications<
  TData = Awaited<ReturnType<typeof getApiNotifications>>,
  TError = GetApiNotifications401 | GetApiNotifications403,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotifications>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotifications>>,
          TError,
          Awaited<ReturnType<typeof getApiNotifications>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiNotifications<
  TData = Awaited<ReturnType<typeof getApiNotifications>>,
  TError = GetApiNotifications401 | GetApiNotifications403,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotifications>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotifications>>,
          TError,
          Awaited<ReturnType<typeof getApiNotifications>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiNotifications<
  TData = Awaited<ReturnType<typeof getApiNotifications>>,
  TError = GetApiNotifications401 | GetApiNotifications403,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotifications>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get notifications
 */

export function useGetApiNotifications<
  TData = Awaited<ReturnType<typeof getApiNotifications>>,
  TError = GetApiNotifications401 | GetApiNotifications403,
>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotifications>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiNotificationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
